import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { ShippingInfo, CartItem, MarketplaceOrderShipping } from "@/types";
import type { ShippingMethod, MarketplaceRetailer } from "@/lib/supabase-api";
import type { DiscountDetail } from "@/lib/discount-store";

export interface OrderDetailsState {
  isMarketplace: boolean;
  shippingDetails: ShippingInfo | null;
  cartItemsByBrand: [string, CartItem[]][];
  marketplaceRetailers: MarketplaceRetailer[];
  totalDiscountDetail: DiscountDetail[];
  totalAppliedDiscount: number;
  automatedDiscountCents: number;
  selectedShippingOption: ShippingMethod | null;
  selectedPickupLocationId: string | null;
  apiConfig: { shipping_config: unknown; base_url: string; type: string; bobgo: boolean } | null;
  shippingCents: number;
  paymentSubtotalCents: number | null;
  paymentShippingCents: number | null;
  paymentDiscountCents: number | null;
  paymentTaxCents: number | null;
  paymentTotalCents: number | null;
  themeId: string | null;
  shipments: MarketplaceOrderShipping[];
  setOrderDetails: (details: Omit<OrderDetailsState, "setOrderDetails" | "clear">) => void;
  clear: () => void;
}

export const useOrderDetailsStore = create<OrderDetailsState>()(
  persist(
    (set) => ({
      isMarketplace: false,
      shippingDetails: null,
      cartItemsByBrand: [],
      marketplaceRetailers: [],
      totalDiscountDetail: [],
      totalAppliedDiscount: 0,
      automatedDiscountCents: 0,
      selectedShippingOption: null,
      selectedPickupLocationId: null,
      apiConfig: null,
      shippingCents: 0,
      paymentSubtotalCents: null,
      paymentShippingCents: null,
      paymentDiscountCents: null,
      paymentTaxCents: null,
      paymentTotalCents: null,
      themeId: null,
      shipments: [],
      setOrderDetails: (details) => set(details),
      clear: () =>
        set({
          isMarketplace: false,
          shippingDetails: null,
          cartItemsByBrand: [],
          marketplaceRetailers: [],
          totalDiscountDetail: [],
          totalAppliedDiscount: 0,
          automatedDiscountCents: 0,
          selectedShippingOption: null,
          selectedPickupLocationId: null,
          apiConfig: null,
          shippingCents: 0,
          paymentSubtotalCents: null,
          paymentShippingCents: null,
          paymentDiscountCents: null,
          paymentTaxCents: null,
          paymentTotalCents: null,
          themeId: null,
          shipments: [],
        }),
    }),
    {
      name: "order-details-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
